import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getter from './getter'
import common from './modules/common'

Vue.use(Vuex)

const setRespondValByKey = function(obj, keyString, val) {
  let current = obj
  const keyArray = keyString.split('.') // 分解key,将字符串转换为数组
  const len = keyArray.length

  if (len > 0) {
    keyArray.forEach((key, index) => {
      if (typeof current[key] === 'undefined') {
        // 如果属性不存在
        if (index < len - 1) {
          // 如果不为最后一个属性,则设置为空对象
          Vue.set(current, key, {})
        } else {
          // 否则,设置值
          Vue.set(current, key, val)
        }
      } else if (index + 1 === len) {
        // 如果原来的对象已经定义,在最后一个属性设置值
        current[key] = val
      }
      current = current[key]
    })
  }
}

export default new Vuex.Store({
  modules: {
    common
  },
  state: {
    user: {},
    site_msg: {}, // 全局的站点信息
    account: localStorage.currentAccount,
    weishengRoute: 'weisheng', // 威盛
    eduteacherRoute: 'eduteacher', // 未来教室
    nocbcmRoute: 'nocbcm', // 未来教室
    examId: 0, // 考试id
    overLink: 0,
    examineeInfo: {},
    hasToken: false,
    testInfo: {}, // 考试信息
    testConfig: {}, // 考试配置
    classUserInfo: {}, // 未来教室信息
    // showTestModal: false, // 考试信息弹出框
    CodemaoCaptcha: '',
    captcha: '',
    captchaType: '',
    phoneNum: '',
    captchaCb: '',
    theme: {
      themeColor: '#347EFD;',
      lightThemeColor: '#E2ECFD;',
      themeSubColor: '#e3efff;',
      buttonShadow: ' 0 6px 12px 0px rgba(57, 126, 253, .3);',
      buttonBackground: 'linear-gradient(135deg,rgba(50,157,252,1) 0%,rgba(57,126,253,1) 100%);'
    }, // 主题色
    browserFinger: '', // 浏览器指纹
    examConfig: {}, // 当前考试的配置项信息
    areaList: [] // 国家/省/市/区数据
  },
  getter,
  actions,
  mutations: {
    /**
     * 更新对应模块下对应键的值
     * @param state
     * @param module {string} 模块名
     * @param key {string} 对应的键
     * @param value 需要更新的值
     */
    setState(state, { module, key, value }) {
      setRespondValByKey(state[module], key, value)
    },
    ...mutations
  }
})
